import React, { useContext } from 'react';
import { Control, Controller, UseFormMethods } from 'react-hook-form';
import { FormUpdater, RadioGroup } from '../../../../hoc/components/inputs';
import { enrollmentContext } from '../../../../hoc/context/enrollment/enrollment-context';
import context from '../../../../hoc/context/product/context';
import { sendGaFocusEvent } from '../../patient/enrollment-ga-events';

export const ExtraPatientInformation: React.FC<{
	hookProps: {
		errors: UseFormMethods['errors'];
		register: UseFormMethods['register'];
	};
	control: Control;
	clearErrors: UseFormMethods['clearErrors'];
}> = ({ hookProps, control, clearErrors }) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);

	return (
		<>
			<Controller
				control={control}
				name={'medication'}
				render={({ onChange, value }) => (
					<RadioGroup
						name="medication"
						label={ctxt.json.getField('medication')?.label}
						ariaLabel={ctxt.json.getField('medication')?.label}
						className="grid grid-cols-1 gap-5 md:grid-cols-5 mt-7"
						radioButtonClassName="col-span-1"
						options={ctxt.json.getField('medication')?.options}
						defaultValue={enrollmentCtxt.getFormField('medication')?.value}
						{...hookProps}
						value={value}
						onChange={(change: React.ChangeEvent<HTMLInputElement>) => {
							onChange(change);
							clearErrors('medication');
						}}
						onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
							//TODO: Use analytics props and remove onFieldFocus
							sendGaFocusEvent(event.target.name);
						}}
					/>
				)}
			/>
			<FormUpdater control={control} controlName={'medication'} />
		</>
	);
};

export default ExtraPatientInformation;
